import { getContainer } from '@framework/di/getContainer';
import ScorecardRepository from '@/creditflowresearch/infrastructure/repository/ScorecardRepository';
import createAsyncRequest from '@/creditflowresearch/infrastructure/state/createAsyncRequest';
import actionTypes from './actionTypes';
import createAction from '@framework/state/createAction';
import { ITtmFilter } from '@/creditflowresearch/application/League/interfaces';
import { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';

interface IProps {
  page: number,
  perPage: number,
  selectedPeriod: ITtmFilter,
  searchText: string,
}

export default ({ page, perPage, selectedPeriod, searchText }: IProps, dispatch) => {
  const container = getContainer();
  const scorecardRepository: ScorecardRepository = container.get(ScorecardRepository);
  const {
    includedRegionIds,
    includedProductIds,
  } = usePageFiltersContext();

  const getRatingAgencies = (payload) => {
    const method = () => scorecardRepository.getCompaniesRatingAgency(payload);
    const request = createAsyncRequest<typeof method>({
      dispatch,
      method,
      types: [
        actionTypes.GET_COLLECTION,
        actionTypes.GET_COLLECTION_SUCCESS,
        actionTypes.GET_COLLECTION_ERROR,
      ],
    });

    return request();
  };

  const paginateRatingAgencies = (payload) => dispatch(createAction(actionTypes.PAGINATE, payload));
  const itemsPerPageRatingAgencies = (payload) => dispatch(createAction(actionTypes.ITEMS_PER_PAGE, payload));
  const resetRatingAgencies = () => dispatch(createAction(actionTypes.RESET));
  const setRatingAgenciesData = (payload) => dispatch(createAction(actionTypes.GET_COLLECTION_SUCCESS, payload));

  const getRatingAgenciesByFilter = () => {
    const payload = {
      page,
      perPage,
      filters: {
        search: searchText || '',
        dateFrom: selectedPeriod.dateFrom,
        dateTo: selectedPeriod.dateTo,
        includedProductIds,
        includedRegionIds,
      },
    };

    getRatingAgencies(payload);
  };

  return {
    getRatingAgenciesByFilter,
    paginateRatingAgencies,
    itemsPerPageRatingAgencies,
    resetRatingAgencies,
    setRatingAgenciesData,
  };
};
